// extracted by mini-css-extract-plugin
module.exports = {"Label":"Input_Label__oDG0c","Input":"Input_Input__WsNqK","ErrorMessage":"Input_ErrorMessage__inUis"};